<page-heading
  [title]="'report.tabulationAttendance.title' | translate"
  [description]="'report.tabulationAttendance.description' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="formGroup">
          <div class="row g-2">
            <div class="col-xs-12 col-lg-6 input-trend-search">
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="'report.tabulationAttendance.searchPlaceholder' | translate"
                (keyup)="search(searchBox.value)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>
            <div class="col-xs-12 col-lg-3 trend-datepicker">
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.tabulationAttendance.startDate' | translate"
                  formControlName="dateStart"
                />
                <input
                  matEndDate
                  [placeholder]="'report.tabulationAttendance.endDate' | translate"
                  formControlName="dateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                  <mat-select
                    class="input-field rounded-lg"
                    (selectionChange)="onPeriodChange($event)"
                    [placeholder]="'report.tabulationAttendance.selectPlaceholder' | translate"
                  >
                    <mat-option value="1">{{ 'report.tabulationAttendance.today' | translate }}</mat-option>
                    <mat-option value="7">{{ 'report.tabulationAttendance.last7Days' | translate }}</mat-option>
                    <mat-option value="15">{{ 'report.tabulationAttendance.last15Days' | translate }}</mat-option>
                    <mat-option value="30">{{ 'report.tabulationAttendance.last30Days' | translate }}</mat-option>
                    <mat-option value="60">{{ 'report.tabulationAttendance.last60Days' | translate }}</mat-option>
                  </mat-select>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    OK
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>
            <div
              class="col-xs-6 col-md-6 col-lg-3 gap-2 btn-group trend-button"
            >
              <button
                class="btn btn-primary fw-bold"
                [disabled]="isLoading"
                [ngClass]="{
                  'cursor-not-allowed opacity-50': isLoading,
                  'cursor-pointer': !isLoading
                }"
                (click)="exportAttendanceReportToExcel()"
                [matTooltip]="'report.tabulationAttendance.exportExcel' | translate"
              >
                @if (isLoading) {
                <mat-spinner [diameter]="25" mode="indeterminate"></mat-spinner>
                } @else {
                <i class="ri-file-text-line"></i>
                }
              </button>

              <button
                class="btn btn-primary fw-bold"
                [disabled]="isLoading"
                [ngClass]="{
                  'cursor-not-allowed opacity-50': isLoading,
                  'cursor-pointer': !isLoading
                }"
                (click)="exportAttendanceReportToPdf()"
                [matTooltip]="'report.tabulationAttendance.exportPdf' | translate"
              >
                @if (isLoading) {
                <mat-spinner [diameter]="25" mode="indeterminate"></mat-spinner>
                } @else {
                <i class="ri-share-box-fill"></i>
                }
              </button>
            </div>
          </div>
          <div class="row g-2 mt-2">
            <div
              class="col-xs-12 col-md-6 col-xl-3 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterChannel"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelChannel | translate }}</span>
              </button>
              <mat-menu #filterChannel="matMenu">
                @if (listChannel.length > 0) {
                <button mat-menu-item (click)="searchByChannel(null)">
                  {{ 'report.tabulationAttendance.all' | translate }}
                </button>
                @for (channel of listChannel; track $index) {
                <button mat-menu-item (click)="searchByChannel(channel)">
                  {{ channel.name }}
                </button>
                } } @else {
                <h6 class="text-muted m-1">{{ 'report.tabulationAttendance.noResultsFound' | translate }}</h6>
                }
              </mat-menu>
            </div>
            <div
              class="col-xs-12 col-md-6 col-xl-3 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterDepartmentAtt"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
              >
                <span>{{ labelDepartment | translate }}</span>
              </button>
            </div>
            <mat-menu #filterDepartmentAtt="matMenu" class="custom-menu-panel">
              <button mat-menu-item (click)="searchByDepartment(null)">
                {{ 'report.tabulationAttendance.all' | translate }}
              </button>
              @for (department of listDepartmentChannel; track $index) {
              <button mat-menu-item (click)="searchByDepartment(department)">
                {{ department.name }}
              </button>
              }
            </mat-menu>
            <div
              class="col-xs-12 col-md-6 col-xl-3 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterTabulation"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
              >
                <span>{{ labelTabulationStatus | translate }}</span>
              </button>
            </div>
            <mat-menu #filterTabulation="matMenu" class="custom-menu-panel">
              <button mat-menu-item (click)="searchByTabulationStatus(null)">
                {{ 'report.tabulationAttendance.all' | translate }}
              </button>
              @for (tab of listTabulationChannel; track $index) {
              <button mat-menu-item (click)="searchByTabulationStatus(tab)">
                {{ tab.name }}
              </button>
              }
            </mat-menu>

            @if (isAdmin()) {
            <div
              class="col-xs-12 col-md-6 col-xl-3 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterUserAdm"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelUser | translate }}</span>
              </button>
            </div>
            <mat-menu #filterUserAdm="matMenu" class="custom-menu-panel">
              <button mat-menu-item (click)="searchByUser(null)">{{ 'report.tabulationAttendance.all' | translate }}</button>
              @for (user of attendantsByTeam; track $index) {
              <button mat-menu-item (click)="searchByUser(user)">
                {{ user.name }}
              </button>
              }
            </mat-menu>
            } @if (isSupervisor()) {
            <div
              class="col-xs-12 col-md-6 col-xl-3 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterUserSup"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelUser | translate }}</span>
              </button>
            </div>
            <mat-menu #filterUserSup="matMenu" class="custom-menu-panel">
              <button mat-menu-item (click)="searchByUser(null)">{{ 'report.tabulationAttendance.all' | translate }}</button>
              @for (user of attendantsByTeam; track $index) { @for (user of user.agents;
              track $index) {
              <button mat-menu-item (click)="searchByUser(user)">
                {{ user.name }}
              </button>
              }
              }
            </mat-menu>
            }
          </div>
        </form>
      </div>
    </div>

    @if (!loadingContent) {
    <div class="card-body col-4 mb-3 d-flex align-items-stretch">
      <div class="d-flex flex-wrap">
        <div class="flex-fill">
          <card-graphic-small-component
            [label]="'report.tabulationAttendance.totalAttendances' | translate"
            [icon]="'block'"
            class="w-full"
            [total]="$safeNavigationMigration(this.pager?.total?.toString())"
          />
        </div>
      </div>
    </div>
    }
  </div>
</div>

<div class="card">
  @if (loadingContent) {
  <content-loading-list></content-loading-list>
  } @if (!loadingContent && pager.total === 0) {
  <empty-records-component
    [message]="'report.tabulationAttendance.noAttendancesFound' | translate"
    [subMessage]="'report.tabulationAttendance.noAttendancesSubMessage' | translate"
    [icon]="'mdi mdi-alert-circle-outline'"
  />
  } @if (!loadingContent && pager.total > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'report.tabulationAttendance.colAttendanceStart' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.tabulationAttendance.colCustomer' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.tabulationAttendance.colAgent' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.tabulationAttendance.colChannel' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.tabulationAttendance.colDepartment' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.tabulationAttendance.colClosingReason' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.tabulationAttendance.colObservations' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.tabulationAttendance.colDuration' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (item of pager.list; track item) {
        <tr>
          <td>
            <span>
              {{
                item.createdAt
                  | timezoneDate
                    : "DD/MM/YYYY HH:mm"
                    : getTimezoneCompanyCurrentUser()
              }}
            </span>
          </td>
          <td>
            <span>
              @if (item?.contact?.name?.length > 15) {
              <span matTooltip="{{ item?.contact?.name }}">
                {{ $safeNavigationMigration(item?.contact?.name) | truncate : 15 }}
              </span>
              } @else {
              <span>
                {{ item?.contact?.name }}
              </span>
              }</span
            >
          </td>
          <td>
            @if (!!item?.user?.name) { @if(item?.user?.name?.length > 10) {
            <span matTooltip="{{ item?.user?.name }}">
              {{ item?.user?.name ?? "-" | truncate : 10 }}
            </span>
            } @if (item?.user?.name?.length <= 10) {
            <span>
              {{ item?.user?.name ?? "-" }}
            </span>
            } } @else {
            <span>-</span>
            }
          </td>

          <td>
            <span>
              @if (!!item?.channel?.name) {
              <span class="text-[16px]" matTooltip="{{ item.channel?.name }}">
                {{ $safeNavigationMigration(item.channel?.name) | truncate : 10 }}
              </span>
              } @else {
              <span class="text-[16px]" matTooltip="{{ item?.channel?.name }}">
                {{ $safeNavigationMigration(item?.channel?.name) | truncate : 10 }}
              </span>
              }
            </span>
          </td>
          <td>
            @if (!!item?.department?.name) { @if(item?.department?.name?.length
            > 10) {
            <span matTooltip="{{ item?.department?.name }}">
              {{ item?.department?.name ?? "-" | truncate : 10 }}
            </span>
            } @if (item?.department?.name?.length <= 10) {
            <span>
              {{ item?.department?.name ?? "-" }}
            </span>
            } } @else {
            <span>-</span>
            }
          </td>
          <td>
            @if(!!item?.tabulationStatus?.tabulations.length) {
            <span
              matTooltip="{{ getTabulationStatusName(item.tabulationStatus) }}"
            >
              {{
                getTabulationStatusName(item.tabulationStatus) | truncate : 15
              }}
            </span>
            } @else {
            <span
              matTooltip="{{ getTabulationStatusName(item.tabulationStatus) }}"
            >
              {{
                getTabulationStatusName(item.tabulationStatus) | truncate : 15
              }}
            </span>
            }
          </td>
          <td>
            @if (!!item?.tabulationStatus?.description) {
            <span matTooltip="{{ item.tabulationStatus?.description }}">
              {{ $safeNavigationMigration(item.tabulationStatus?.description) | truncate : 15 }}
            </span>
            } @else {
            <span>-</span>
            }
          </td>
          <td>
            <span>
              {{ getAttendanceDuration(item) }}
            </span>
          </td>
        </tr>
        }
      </tbody>
    </table>

    @if (pager.total > pager.perPage) {
    <paginator [pager]="pager" (onPager)="loadPage($event)"></paginator>
    }
  </div>
  }
</div>
